export default __webpack_public_path__ + "static/media/amazon-web-services-icon.276a61f2.svg";